import React, { useState, useEffect, useMemo } from "react"
import { Button, Form, Input, Upload, Select, Radio } from "antd"
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux'

import { ROUTES, COMMON_FEATURES, TEMPLATE } from "../../../../../../../../constants"

import { uploadHDLR } from "../../../../../../../../handlers"

import { REDUX } from '../../../../../../../../services/util'

// Style
import styles from './index.module.css'
import './index.css'

const { VEHICLE_ISSUE_PRIORITY_TITLE } = TEMPLATE.VAM
const { getBase64, handleBeforeUpload, UploadVehicleIssueImage } = uploadHDLR

const VehicleIssueForm = ({ form, onFinish, data, images, setImages }) => {

    const navigate = useNavigate()

    const vehicles = Object.values(useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID')))
    .map(v => ({ label: v.plate, value: v.vid }))

    const users = Object.values(useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID')))
    .map(v => ({ label: v.name, value: v.uid }))

    const types = Object.values(useSelector(REDUX.reduxStoreWrapper('vamLines.itemByID'))).map(t => ({ label: t.name, value: t.vamlid }));

    const [priority, setPriority] = useState(null);
    const [isUploadReady, setIsUploadReady] = useState(false);

    useEffect(() => {
        if (data) {
            setPriority(data?.priorityLevel);
            setImages(data?.photos || []);
        }
        setIsUploadReady(true); 
    }, [data])

    const handleChangeImg = (info) => {
        const { status, originFileObj, response = {} } = info.file;

        if (status === "uploading") {
            return;
        }
        if (status === "done") {
            getBase64(originFileObj, () => {
                const { url } = response;
                setImages((prevImages = []) => [...prevImages, {url}]);
            });
        }
    };

    const newFileList = useMemo(() =>
        (images || []).map(({ url }, index) => {
          if (!url) return null;
          return {
            uid: `${index}`,
            name: url.split('/').pop(),
            status: 'done',
            url,
          };
    }).filter(Boolean), [images]);

    return (
        <Form 
            style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
            labelCol={{ span: 4 }}
            form={form}
            initialValues={data ?? {}}
            onFinish={onFinish}
        >
            <Form.Item
                label="Vehicle Plate"
                name="vid"
                rules={[
                    {
                        required: true,
                        message: 'Please input vehicle plate!',
                    },
                ]}
                >
                    <Select options={vehicles} />
                </Form.Item>
            <Form.Item
                label="Issue Priority"
                name="priorityLevel"
                rules={[
                    {
                        required: true,
                        message: 'Please input issue priority!',
                    },
                ]}
                >
                    <Radio.Group value={priority} onChange={(e) => setPriority(e.target.value)}>
                        {Object.entries(VEHICLE_ISSUE_PRIORITY_TITLE).map(([key, { name, icon, colorTag, outline, status }]) => (
                            <Radio.Button
                                key={key}
                                value={status}
                                style={{
                                    borderRadius: 20,
                                    marginRight: 8,
                                    background: priority === status ? outline : "#fff",
                                    borderColor: outline,
                                    color: colorTag,
                                    alignItems: "center",
                                    padding: "0 12px",
                                }}
                            >
                                <img src={icon} alt={name} style={{ width: 14, marginRight: 6 }} />
                                {name}
                            </Radio.Button>
                        ))}
                    </Radio.Group>
                </Form.Item>
            <Form.Item
                label="Issue Type"
                name="vamlid"
                rules={[
                    {
                        required: true,
                        message: 'Please input issue type!',
                    },
                ]}
                >
                    <Select options={types} />
            </Form.Item>
            <Form.Item
                label="Issue Description"
                name="desc"
                rules={[
                    {
                        required: true,
                        message: 'Please input issue description!',
                    },
                ]}
                >
                    <Input size="large" />
            </Form.Item>
            <Form.Item
                label="Attachment"
                name="photos"
                > 
                    {isUploadReady && (
                        <Upload
                            listType="picture-card"
                            defaultFileList={newFileList}
                            beforeUpload={handleBeforeUpload}
                            onChange={handleChangeImg}
                            customRequest={UploadVehicleIssueImage}
                        >
                            {'+ Upload'}
                        </Upload>
                    )}
            </Form.Item>
            <Form.Item
                label="Reported By"
                name="updatedBy"
                // rules={[
                //     {
                //         required: true,
                //         message: 'Please input issue description!',
                //     },
                // ]}
                >
                    <Select size="large" options={users} />
                    {/* <Input size="large" /> */}
            </Form.Item>

                <div className={styles['button-container']}>
                    <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.VEHICLE_ISSUES_MANAGEMENT])}>Cancel</Button>
                    <Button className={`${styles['button']} ${styles['add']}`} htmlType="submit">Add</Button>
                </div>
        </Form>
    )
}

export default VehicleIssueForm;